import React from 'react';
import { ClipboardIcon, DollarSignIcon, UserPlusIcon, MessageSquareIcon, CheckCircleIcon } from 'lucide-react';
export const RecentActivity = () => {
  const activities = [{
    id: 1,
    type: 'booking',
    title: 'New Booking Confirmed',
    description: 'Jennifer Williams - Caribbean Cruise',
    time: '2 hours ago',
    icon: <CheckCircleIcon className="h-4 w-4 text-green-500" data-id="element-2286" />
  }, {
    id: 2,
    type: 'payment',
    title: 'Payment Received',
    description: 'Robert Chen - $2,450.00',
    time: '4 hours ago',
    icon: <DollarSignIcon className="h-4 w-4 text-blue-500" data-id="element-2287" />
  }, {
    id: 3,
    type: 'customer',
    title: 'New Customer Added',
    description: 'David Miller - Referred by Michael Torres',
    time: 'Yesterday',
    icon: <UserPlusIcon className="h-4 w-4 text-purple-500" data-id="element-2288" />
  }, {
    id: 4,
    type: 'enquiry',
    title: 'New Enquiry Received',
    description: 'Lisa Wong - Japan Cultural Tour',
    time: 'Yesterday',
    icon: <MessageSquareIcon className="h-4 w-4 text-amber-500" data-id="element-2289" />
  }];
  return <div className="bg-white rounded-lg shadow-md p-4" data-id="element-2290">
      <div className="flex items-center justify-between mb-4" data-id="element-2291">
        <h2 className="text-lg font-medium text-gray-800" data-id="element-2292">Recent Activity</h2>
        <button className="text-sm text-blue-600 hover:text-blue-800" data-id="element-2293">
          View All
        </button>
      </div>
      <div className="space-y-3" data-id="element-2294">
        {activities.map(activity => <div key={activity.id} className="flex items-start p-2 rounded-lg hover:bg-gray-50 transition-colors" data-id="element-2295">
            <div className="p-2 bg-gray-100 rounded-full mr-3" data-id="element-2296">
              {activity.icon}
            </div>
            <div className="flex-1 min-w-0" data-id="element-2297">
              <p className="text-sm font-medium text-gray-800" data-id="element-2298">
                {activity.title}
              </p>
              <p className="text-xs text-gray-600" data-id="element-2299">{activity.description}</p>
            </div>
            <div className="text-xs text-gray-500 whitespace-nowrap" data-id="element-2300">
              {activity.time}
            </div>
          </div>)}
      </div>
    </div>;
};